'use client';

import { AI_CAPACITY_LICENSE_ENABLED_FLAG } from '@terra/shared-contracts-feature-flags';
import { FullRescanLastRunCard } from '@terra/ui-design-system';
import { useLatestApplicationFullRescan } from '../../../hooks/api/useApplicationFullRescan';
import { useFeatureFlags } from '../../../hooks/useFeatureFlags';

type FullRescanStatusCardProps = {
  applicationId: string;
};

export function FullRescanStatusCard({
  applicationId,
}: FullRescanStatusCardProps) {
  const { isFeatureFlagEnabled } = useFeatureFlags(
    AI_CAPACITY_LICENSE_ENABLED_FLAG,
  );
  const { data } = useLatestApplicationFullRescan({
    applicationId,
    enabled: isFeatureFlagEnabled,
  });
  const run = data?.run ?? null;

  if (!isFeatureFlagEnabled || !run) {
    return null;
  }

  return <FullRescanLastRunCard run={run} />;
}
